/* eslint-disable no-unused-vars */
import React, { ReactNode, useState } from 'react';
import style from './circle.module.scss';
import cx from 'classnames';

export default function Circle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const [isMousePressed, setIsMousePressed] = useState(false);

  return (
    <div
      onMouseDown={() => {
        setIsMousePressed(true);

        const listener = () => {
          setIsMousePressed(false);
          document.removeEventListener('mouseup', listener, true);
        };

        document.addEventListener('mouseup', listener, true);
      }}
      className={cx(
        style.container,
        className,
        isMousePressed ? style.isPressed : ''
      )}
    >
      {children}
    </div>
  );
}
